module.exports = __webpack_public_path__ + "static/macbook-d7bdddfb57fd7c5aab17620ddd7ba4d6.png";